import styled from 'styled-components';
import {dFlex, alignCenter, justifyBetween} from '../../../../../../globalVariables/GlobalFlex';
import {BGImageCenter, HOVER_BLUE, WHITE, LIGHT_GRAY, MANDATORY_BG, OPTIONAL_PURPLE_BG, LIGHT_GRAY2, ellipsis} from '../../../../../../globalVariables/GlobalVariables';
import {arrowDown} from '../../../../../../assets/symbols/symbols/Symbols.css';

export const state = styled.div`
    position: relative;
    width: 80px;
`;

export const eventKindButton = styled.button<{eventKind: string | null}>`
    padding: 0 6px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
    
    background: ${props => {
    if(props.eventKind === 'mandatory') return MANDATORY_BG;
    if(props.eventKind === 'optional') return OPTIONAL_PURPLE_BG;
    return WHITE;
}};
    cursor: pointer;
    
    &:disabled {
        background: ${LIGHT_GRAY2};
        cursor: not-allowed;
    }
    
    &:focus {
        outline: none;
        border-color: ${HOVER_BLUE};
    }
`;

export const eventKindContent = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyBetween}
    gap: 4px;
    height: 24px;
    ${ellipsis}
    &::after {
        content: '';
        height: 15px;
        width: 15px;
        ${BGImageCenter(arrowDown)} 
    }
`;
